export const config = { 
    storageType: 's3', // local / s3
    storageS3Url: 'https://opengym-upload.s3.amazonaws.com/',
    APIbaseURL: 'https://backend.opengym.com.br'
 };

// APIbaseURL: 'http://localhost:21143'
// APIbaseURL: 'https://backend.opengym.com.br' // railway